import { createSlice } from "@reduxjs/toolkit";
import { isLoggedIn } from "src/utilities/SessionService";

export const defaultRootDialogDTO = {
  show: false,
  timer: false,
  type: null,
  message: null,
};

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,

  loading: false,

  isAuthenticated: isLoggedIn(),

  rootDialogDTO: defaultRootDialogDTO,
};

export const rootSlice = createSlice({
  name: "root",
  initialState,
  reducers: {
    sidebarShow: (state, action) => {
      state.sidebarShow = action.payload;
      return state;
    },
    sidebarUnfoldable: (state, action) => {
      state.sidebarUnfoldable = action.payload;
      return state;
    },
    loading: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.loading = action.payload;
      return state;
    },
    authentication: (state, action) => {
      state.isAuthenticated = action.payload;
      return state;
    },
    updateRootDialogDTO: (state, action) => {
      state.rootDialogDTO = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { sidebarShow, sidebarUnfoldable, loading, authentication, updateRootDialogDTO } = rootSlice.actions;

export default rootSlice.reducer;
